// extracted by mini-css-extract-plugin
export default {"EmploymentType":"employment-type_EmploymentType__L7WIz"};